import type { Row } from './types';

export function mapRows(rows: Row[], mapping: Record<string, string>): Row[] {
  return rows.map((row) => {
    const mapped: Row = {};
    for (const [key, value] of Object.entries(row)) {
      const internalKey = mapping[key];
      if (internalKey === undefined) continue;
      mapped[internalKey] = typeof value === 'string' ? value.trim() : value;
    }
    return mapped;
  });
}
